import React from 'react';
import { FiSliders, FiWifi, FiPlusCircle, FiTrendingUp, FiRefreshCw, FiTrash2 } from 'react-icons/fi';

const DetailFooterActions = () => {
  // Main blue action config data mapping to your design text labels
  const mainActions = [
    { label: 'Calibrate Sensor', icon: FiSliders },
    { label: 'Test Connection', icon: FiWifi },
    { label: 'Add Manual Reading', icon: FiPlusCircle },
    { label: 'View All Readings', icon: FiTrendingUp },
  ];

  return (
    <div className="w-full font-sans select-none flex flex-col xl:flex-row xl:items-center justify-between gap-6 bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_2px_12px_rgba(0,0,0,0.01)]">
      
      {/* Left Column Container: Quick Actions Control Area */}
      <div className="space-y-4 flex-1">
        {/* Section Heading Title */}
        <h3 className="text-[15px] font-bold text-gray-800 tracking-tight">
          Quick Actions
        </h3>

        {/* Buttons Flex Row Pack */}
        <div className="flex flex-wrap items-center gap-3">
          
          {/* Blue Utility Buttons Group Loop */}
          {mainActions.map((action, idx) => {
            const ActionIcon = action.icon;
            return (
              <button
                key={idx}
                className="inline-flex items-center justify-center gap-2 bg-white border border-gray-100 hover:border-gray-200 hover:bg-gray-50/50 active:bg-gray-50 p-2.5 px-4 rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.01)] transition-all cursor-pointer group text-[#0052FF]"
              >
                <ActionIcon className="w-[15px] h-[15px] shrink-0 stroke-[2.2]" />
                <span className="text-[12px] font-bold tracking-tight whitespace-nowrap">
                  {action.label}
                </span>
              </button>
            );
          })}

          {/* Red Administrative/Destructive Buttons Divider Container Group */}
          <div className="inline-flex items-center rounded-xl overflow-hidden border border-red-100 bg-white shadow-[0_1px_3px_rgba(0,0,0,0.01)] text-red-500 divide-x divide-red-100">
            {/* Replace Button Item */}
            <button className="inline-flex items-center gap-2 hover:bg-red-50/40 active:bg-red-50 p-2.5 px-4 transition-colors cursor-pointer font-bold text-[12px] tracking-tight whitespace-nowrap">
              <FiRefreshCw className="w-3.5 h-3.5 stroke-[2.5]" />
              <span>Replace Sensor</span>
            </button>
            {/* Remove Button Item */}
            <button className="inline-flex items-center gap-2 hover:bg-red-50/40 active:bg-red-50 p-2.5 px-4 transition-colors cursor-pointer font-bold text-[12px] tracking-tight whitespace-nowrap">
              <FiTrash2 className="w-3.5 h-3.5 stroke-[2.2]" />
              <span>Remove Sensor</span>
            </button>
          </div>

        </div>
      </div>

      {/* Right Column Container: Peach Colored Support Ticket Help Banner */}
      <div className="bg-[#FFF8F2] border border-[#FFEADA] rounded-xl p-4 px-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 min-w-full xl:min-w-[420px] max-w-full xl:max-w-[460px]">
        <div className="space-y-1">
          <h4 className="text-[14px] font-extrabold text-gray-900 tracking-tight leading-none">
            Need help or see an issue?
          </h4>
          <p className="text-[11px] font-semibold text-gray-500 leading-normal">
            Create a maintenance request or contact support.
          </p>
        </div>

        {/* Orange Report Issue Ticket Submission Button Trigger */}
        <button className="bg-white border border-[#FFD9BC] hover:border-[#FFC8A0] text-[#E67E22] font-bold text-[12px] tracking-tight px-4 py-2 rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.01)] hover:bg-orange-50/20 active:bg-orange-50/50 transition-all cursor-pointer whitespace-nowrap self-stretch sm:self-auto text-center">
          Report Issue
        </button>
      </div>

    </div>
  );
};

export default DetailFooterActions;
